export var EField;
(function (EField) {
    EField["Types"] = "types";
    EField["From"] = "from";
    EField["To"] = "to";
})(EField || (EField = {}));
